import { useContext } from 'react'
import { utils, components } from '@digital-commerce/shared-utils'
import { Spacer } from '@telus-uds/components-web'
import { object } from 'prop-types'
import { ResponsiveCard } from '../StyledContainers'

import CartItem, { BasicInfo, ActionBar, OfferDetailsContainer } from '../../molecules/CartItem'
import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'
import useAuthentication from '../../../hooks/useAuthentication'
import {
  getAddonTotalMonthlyPrice,
  getFootNoteKey,
  setUrlByAuthenticationAndService,
  isSHSWithTOS,
  isIncludedAddon
} from './utils'
import OfferDetails from './OfferDetails'
import { buildContractTermLabel } from '../../../utils/display'
import { transformCancellationFeeContent, isHSExistingCustomer } from '../../../utils/cart'

const { getItemTotalFirstBill, isBusinessCart } = utils.cart
const { WithLegal } = components

const Addon = ({ addon, cart, featureFlags }) => {
  const translate = useTranslate()
  const isAuthenticated = useAuthentication()
  const { lang } = useContext(localeContext)
  const { subTotal: firstBillSubTotal = 0 } = getItemTotalFirstBill(addon) ?? {}
  const { subTotal: monthlySubTotal } = getAddonTotalMonthlyPrice(addon) ?? {}
  const addonIncluded = isIncludedAddon(cart, addon, featureFlags)
  const subHeading = addonIncluded ? translate('subHeadingSHSTOS') : translate('subHeading')
  const changeUrl = setUrlByAuthenticationAndService({
    isAuthenticated,
    service: addon,
    cart,
    featureFlags,
    isBusinessCart: isBusinessCart(cart),
    addonIncluded
  })
  // term is not shown if the add-on is included with another product
  const term = !addonIncluded && buildContractTermLabel(translate, addon)
  const legalFootNoteKey = getFootNoteKey(addon)
  const termsAndConditions = legalFootNoteKey && (
    <WithLegal
      content={translate(legalFootNoteKey)}
      onReceiveContent={transformCancellationFeeContent(addon, lang)}
      copy={lang}
    />
  )
  return (
    <>
      <ResponsiveCard variant={{ border: 'line', padding: 'custom' }}>
        <CartItem cartItem={addon}>
          <BasicInfo
            subHeading={subHeading}
            firstBillSubTotal={firstBillSubTotal}
            monthlySubTotal={monthlySubTotal}
            hidePricing={addonIncluded}
            changeUrl={changeUrl}
            term={term}
            termsAndConditions={termsAndConditions}
          />
          <ActionBar
            isShowDetailsCtaHidden={addonIncluded}
            isRemoveButtonHidden={isSHSWithTOS(cart, addon) || isHSExistingCustomer(cart)}
          />
          <OfferDetailsContainer>
            <OfferDetails addon={addon} cart={cart} />
          </OfferDetailsContainer>
        </CartItem>
      </ResponsiveCard>
      <Spacer space={5} />
    </>
  )
}

export default Addon

Addon.propTypes = {
  addon: object.isRequired,
  cart: object.isRequired,
  featureFlags: object.isRequired
}
